const rtf = new Intl.RelativeTimeFormat('ko', { numeric: 'auto' });

let tsCache = new Map<string, string>();
let tsCacheEpoch = 0;

function getTsCacheEpoch(): number {
  return Math.floor(Date.now() / 60_000);
}

export function formatTimestamp(iso: string): string {
  const epoch = getTsCacheEpoch();
  if (epoch !== tsCacheEpoch) {
    tsCache = new Map();
    tsCacheEpoch = epoch;
  }

  const cached = tsCache.get(iso);
  if (cached) return cached;

  const date = new Date(iso);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const target = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.round((today.getTime() - target.getTime()) / (1000 * 60 * 60 * 24));

  let result: string;

  if (diffDays === 0) {
    result = date.toLocaleTimeString('ko-KR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } else if (diffDays === 1) {
    result = rtf.format(-1, 'day');
  } else if (now.getFullYear() === date.getFullYear()) {
    result = date.toLocaleDateString('ko-KR', { month: 'long', day: 'numeric' });
  } else {
    result = date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  tsCache.set(iso, result);
  return result;
}

const pad2 = (n: number) => String(n).padStart(2, '0');

/** 시:분(24시간). 날짜 구분선 바로 아래처럼 날짜가 이미 보이는 자리에 쓴다. */
export function formatClock(iso: string): string {
  const d = new Date(iso);
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

/** 월.일 시:분 — 여러 날에 걸친 기록 한 줄에 쓴다. */
export function formatLogStamp(iso: string): string {
  const d = new Date(iso);
  return `${pad2(d.getMonth() + 1)}.${pad2(d.getDate())} ${formatClock(iso)}`;
}

export function formatDateSeparator(iso: string): string {
  const date = new Date(iso);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const target = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.round((today.getTime() - target.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return '오늘';
  if (diffDays === 1) return '어제';

  return date.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
